var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import analytics from '../analytics/analytics';
const FEEDBACK_URL = 'https://qaa.priceline.com/genai-svc/genai/chat/feedback';
export const feedbackPost = (args, url, headers) => __awaiter(void 0, void 0, void 0, function* () {
  const abortController = new AbortController();
  const timeoutId = setTimeout(() => {
    abortController.abort();
  }, 30000); // 30 seconds timeout for fetch request
  try {
    const res = yield fetch(url || FEEDBACK_URL, {
      method: 'POST',
      body: JSON.stringify(args),
      headers: Object.assign({
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache'
      }, headers),
      signal: abortController.signal
    });
    clearTimeout(timeoutId);
    return yield res.json();
  } catch (e) {
    const {
      cguid,
      conversationId,
      message,
      feedbackId
    } = args;
    analytics.log({
      message: 'Failed to submit Feedback',
      cguid,
      conversationId,
      content: message.content,
      vote: message.vote,
      feedbackId
    });
  }
});